import React, { lazy, Suspense, useCallback, useMemo, useState } from "react";
import { SubHeading } from "../../shared/Components";
import CommonModal from "../../shared/Components/Modal/CommonModal";

const SettledMarketBody = lazy(() => import("./SettledMarketBody"));
const SettledMarket = () => {
  const [isShow, setIsShow] = useState({
    isOpen: false,
    rowData: null,
    name: "",
    modalTitle: "",
    modalContent: null,
    apiFlag: false,
    handleReopen: null,
  });

  return (
    <>
      <SubHeading isAddBtn={false} />

      <Suspense fallback={<div>Loading...</div>}>
        <SettledMarketBody handleModal={setIsShow} />
      </Suspense>

      {isShow.isOpen && (
        <CommonModal
          isShow={isShow.isOpen}
          size="md"
          handleModalHide={() =>
            setIsShow((prev) => ({
              ...prev,
              isOpen: false,
              rowData: {},
              name: "",
            }))
          }
          modalTitle={isShow.modalTitle}
        >
          {isShow.modalContent &&
            React.createElement(isShow.modalContent, {
              handleShowHide: () =>
                setIsShow((prev) => ({
                  ...prev,
                  isOpen: false,
                  rowData: {},
                  name: "",
                  modalTitle: "",
                })),
              rowData: isShow.rowData,
              handleFn: isShow.handleReopen,
            })}
        </CommonModal>
      )}
    </>
  );
};

export default SettledMarket;
